import React from "react";

/**
 * 2026-10-27: Dagens leveringsadresser fra kalenderen (kundens eller lokationens):
 * den primære og alternativerne - hver med egne tider eller "lukket". Standard er
 * dagens (den primære - eller det første åbne alternativ, når den er lukket), og der
 * kan skiftes. "Andre" er resten af pladsens liste (uden tider for dagen).
 *
 * options: [{id, label, line, kind: primary|alternative|other, open_from, open_to, closed}]
 */
export const optHours = (o) => (o?.closed ? "lukket" : o?.open_from && o?.open_to ? `${o.open_from}–${o.open_to}` : "");

/** Nye tider ved skift af adresse - medmindre tiderne er rettet i hånden. */
export const hoursFor = (o) => (o && !o.closed ? { open_from: o.open_from || "", open_to: o.open_to || "" } : { open_from: "", open_to: "" });

const STYLES = {
  light: {
    on: "bg-emerald-600 border-emerald-600 text-white",
    off: "border-slate-200 dark:border-slate-600 text-slate-700 dark:text-slate-200 hover:border-emerald-400",
    closed: "border-amber-300 dark:border-amber-800 text-amber-800 dark:text-amber-200 bg-amber-50 dark:bg-amber-950/30",
    select: "px-2 py-1.5 rounded-lg border border-slate-200 dark:border-slate-600 bg-white dark:bg-slate-800 text-xs",
  },
  dark: {
    on: "bg-orange-500 border-orange-500 text-white",
    off: "border-slate-600 text-slate-200 hover:border-orange-400",
    closed: "border-amber-500/50 text-amber-300 bg-amber-500/10",
    select: "px-2 py-1 rounded-lg border border-slate-600 bg-slate-900 text-slate-200 text-[11px]",
  },
};

export default function DeliveryOptions({ options = [], value, onPick, variant = "light", testid = "delivery-options", min = 2 }) {
  const st = STYLES[variant] || STYLES.light;
  // Få adresser: alle som knapper. Mange: resten af pladsens liste i en liste.
  const few = options.length <= 7;
  const main = options.filter((o) => few || o.kind !== "other");
  const other = few ? [] : options.filter((o) => o.kind === "other");
  if (options.length < min) return null;
  return (
    <div className="flex flex-wrap items-center gap-1.5" data-testid={testid}>
      {main.map((o) => {
        const on = value === o.id;
        const h = optHours(o);
        return (
          <button key={o.id} type="button" title={o.line || "Mangler adresse"} onClick={() => onPick(o)}
            className={`px-2.5 py-1.5 rounded-lg border text-xs font-semibold text-left leading-tight ${on ? st.on : o.closed ? st.closed : st.off}`}
            data-testid={`${testid}-opt`} data-kind={o.kind}>
            <span className="block">{o.label}{o.kind === "primary" && <span className="ml-1 font-normal opacity-80">(primær)</span>}</span>
            {h && <span className={`block text-[10px] font-normal ${on ? "opacity-90" : "opacity-75"}`}>{h}</span>}
          </button>
        );
      })}
      {other.length > 0 && (
        <select className={st.select} value={other.some((o) => o.id === value) ? value : ""}
          onChange={(e) => { const o = other.find((x) => x.id === e.target.value); if (o) onPick(o); }} data-testid={`${testid}-other`}>
          <option value="">{main.length ? "Andre leveringsadresser…" : "Vælg leveringsadresse…"}</option>
          {other.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
      )}
    </div>
  );
}
